export default __webpack_public_path__ + "static/media/doc.c897f9f2.svg";